import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, LoadingController } from 'ionic-angular';

import { BusinessModifierGroupManagerHandler } from '../../providers/business-modifier-group-handler';

import { Globals } from '../../providers/globals';

@Component({
  selector: 'page-business-product-subcategory-modifier-group-list',
  templateUrl: 'business-product-subcategory-modifier-group-list.html',
})
export class BusinessProductSubcategoryModifierGroupListPage {
	subcategory: any;
	groups: any;
	hasModifiers: boolean = false;
	filePath: any;
	loader: any;
	isLoading: boolean = false;

	loadingMsg: any = "Loading...";
	isRefreshing: boolean = false;
	lastRequestReturnedValues: boolean = false;

	params: any = {
		page: 1,
		size: 20,
		cb: null
	}

  	constructor(
  		public navCtrl: NavController, 
		public navParams: NavParams,
		public managerHandler: BusinessModifierGroupManagerHandler,
		public alertCtrl: AlertController,
		public loadingCtrl: LoadingController,
		public globals: Globals,
		) {
		this.filePath = this.globals.fileUrl;

		this.subcategory = navParams.data["subcategory"];
  	}

  	ionViewWillEnter() {
		if(this.subcategory.Id){
	   		this.load(this.subcategory.Id);
	    }
	}

	load(id){
		this.isLoading = true;

		this.managerHandler.getAvailableModifierGroups(id, (result)=>{
		  	
		  	this.groups = result;

		  	this.hasModifiers = this.groups.length>0;

			this.isLoading = false;


		  	this.isLoading = false;
		})
	}

	doRefresh(refresher) {
		this.isRefreshing = true;

		this.load(()=>{
			this.isRefreshing = false;
		  	refresher.complete();
		})
	}  	

	// doInfinite(infiniteScroll){
	// 	if(!this.lastRequestReturnedValues){
	// 		infiniteScroll.complete();
	// 		return;
	// 	} 

	// 	this.isRefreshing = true;

	// 	this.params.page++;

	// 	this.load(()=>{
	// 		this.isRefreshing = false;
			
	// 		infiniteScroll.complete();
	// 	});
	// }		

	toggle(modifierGroup){	
		var isSelected;

	  	if(modifierGroup.IsSelected){
	  		isSelected = false;	
	  	}else{
	  		isSelected = true;	
	  	}  		 

	  	var params = {
	  		id: modifierGroup.Id,
	  		subCategoryId: this.subcategory.Id,
	  		isSelected: isSelected
	  	}

	  	this.managerHandler.toggleModifierGroup(params, ()=>{
		    modifierGroup.IsSelected = isSelected
	    })
  	} 

}



// WEBPACK FOOTER //
// ./src/pages/business-product-subcategory-modifier-group-list/business-product-subcategory-modifier-group-list.ts